import React, { useEffect, useState } from 'react'
import MasterService from '../MasterService';
import Header from '../../Component/Header';
import Menu from '../../Component/Menu';
import { spin } from '../../Common/NewLoader';
import { createTheme, ThemeProvider, Tooltip } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import moment from 'moment';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import { Link } from 'react-router-dom';
import Footer from '../../Component/Footer';
import CustomToolbar from '../../CommonComponents/CustomToolbar';
import withRouter from '../../withRouter';
import Swal from 'sweetalert2';


import deleteIcon from "../../images/Icons/delete.png";
import addUserIcon from "../../images/Icons/add-user.png";
import Breadcrumb from '../../NewUI/NewComponents/Breadcrumb';

const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
        border: [[1, "solid", "#ece6e6"]],
      },
      body: {
        border: [[1, "solid", "#ece6e6"]],
      },
    },
  },
});

const PrefixType = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    Refresh()
  }, []);

  const Refresh = () => {
    setLoading(true);
    MasterService.getallprefixtypes().then((response) => {
      setData(response.data);
      setLoading(false);
    });
  }

  const deletePrefix = (type) => {
    let id = data.find(e => e.prefixtype === type)?.id
    MasterService.DeletePrefixType(id).then(() => Refresh()).catch(() => Swal("Erro", "", "error"))
  }

  const AddPrefixtoTenants = (e) => {
    MasterService.AddPrefixtoTenants(e).then(() => Refresh())
      .catch((e) => console.log(e))
  }

  const columns = [
    { name: "prefixtype", label: "Prefix Type", options: { filter: true, sort: true } },
    { name: "prefix", label: "Default Prefix", options: { filter: true, sort: true } },
    // {
    //   name: "createdAt",
    //   label: "Date",
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (tableMeta) =>
    //       moment(tableMeta).format("DD-MM-YYYY HH:mm"),
    //   },
    // },

    {
      name: "status",
      label: "Action", // fixed typo
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowId = tableMeta.rowData.find((e) => e);

          return value === "INACTIVE" && (
            <>
              {/* Delete Icon */}
              <span
                role="button"
                tabIndex={0}
                className="cursorpointer mr-3"
                onClick={() => {
                  if (window.confirm(`Are you sure you wish to delete?`)) {
                    deletePrefix(rowId);
                  }
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    if (window.confirm(`Are you sure you wish to delete?`)) {
                      deletePrefix(rowId);
                    }
                  }
                }}
              >
                <Tooltip title="Delete">
                  <img
                    src={deleteIcon}
                    alt="Delete"
                    style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }}
                  />
                </Tooltip>
              </span>

              {/* Add Prefix Icon */}
              <span
                role="button"
                tabIndex={0}
                className="cursorpointer"
                onClick={() => AddPrefixtoTenants(rowId)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    AddPrefixtoTenants(rowId);
                  }
                }}
              >
                <Tooltip title="Add Prefix">
                  <img
                    src={addUserIcon}
                    alt="Add Prefix"
                    style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }}
                  />
                </Tooltip>
              </span>
            </>
          );
        },
      },
    }

  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    customToolbar: () => {
      return (
        <>
          <Link
            as="button"
            className="float-right btn btn-sm m-0 p-0"
            to={{ pathname: "/newprefixtype" }}
          >
            <CustomToolbar />
          </Link>
        </>
      );
    },
  };

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="UI-container">
          <div className='UI-card'>
        <div className={`UI-header`}>
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/superadminmasters"},{name:"Prefix Types",path:null}]}/>
        </div>
            <div className="UI-table-container">
                <div>
                  {loading === true ? (
                    <div className="text-center">{spin}</div>
                  ) : (

                      <ThemeProvider theme={theme}>
                        <MUIDataTable
                          className="table-sm"
                          title={"Prefix Types"}
                          data={data}
                          columns={columns}
                          options={options}
                        />
                      </ThemeProvider>
                  )}
                </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );

}

export default withRouter(PrefixType)